module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJNJREFUOBHdk9ENgCAMRFt3cRldCCZgIhxGh6mS+NWcpcRoCPyVHi9HOYh6WCGE3etj8gpv3ezVt4K9XGJLGWPMIrI8aZh5SymtqG86tqAFZvVNMHLi3RsMXB6ncvVc6fva1wcRn5LosxnDHNfyq12jPEPHVj41tNRID8HocOveIGBHfvVk3uW5ixy3Pt6hZ/B7fQIQ2SgpAOrsygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignCenter_disabled.png
// module id = 305
// module chunks = 0